import { defineStore } from 'pinia';
import { ref, inject, computed } from 'vue';
import dayjs from 'dayjs';

export const useBrandKeywordsStore = defineStore('brandKeywords', () => {
  const axios = inject('axios');
  const positiveKeywords = ref([]);
  const negativeKeywords = ref([]);

  const notActiveKeywords = computed(() => positiveKeywords.value.filter((item) => !item.active));

  const nextScanDate = computed(() => {
    if (notActiveKeywords.value.length > 0) {
      const farKeyword = notActiveKeywords.value.sort((a, b) => {
        if (b.availableAt.timestamp > a.availableAt.timestamp) {
          return 1;
        }
        if (a.availableAt.timestamp > b.availableAt.timestamp) {
          return -1;
        }
        return 0;
      });
      return dayjs.unix(farKeyword[0].availableAt.timestamp).format('DD.MM.YYYY HH:mm');
    }

    return false;
  });

  async function getBrandKeywords(brandGuid, params = {}) {
    const { data } = (await axios.get(`/reply/brands/${brandGuid}/keywords`, { params })).data;
    return data;
  }

  async function getPositiveKeywords(brandGuid, params = {}) {
    const { elements } = await getBrandKeywords(brandGuid, { positive: true, ...params });
    positiveKeywords.value = elements;
    return elements;
  }

  async function getNegativeKeywords(brandGuid, params = {}) {
    const { elements } = await getBrandKeywords(brandGuid, { positive: false, ...params });
    negativeKeywords.value = elements;
  }

  async function removeBrandKeyword(brandGuid, keywordGuid = {}) {
    await axios.delete(`/reply/brands/${brandGuid}/keywords/${keywordGuid}`);
  }
  async function createKeyword(brandGuid, form = {}) {
    await axios.post(`/reply/brands/${brandGuid}/keywords`, form);
  }

  async function actualizeKeyword(brandGuid, keywords) {
    return (await axios.put(`/reply/brands/${brandGuid}/keywords/actualize`, { keywords })).data;
  }

  return {
    getPositiveKeywords,
    getNegativeKeywords,
    removeBrandKeyword,
    createKeyword,
    positiveKeywords,
    negativeKeywords,
    actualizeKeyword,
    nextScanDate,
    notActiveKeywords,
  };
});
